import type { TalentTree } from '../../CharacterTypes';

export const PALADIN_TALENTS: TalentTree = {
    'holy': [
      {
        id: 'paladin_strength',
        name: 'Holy Strength',
        description: 'Increase strength by 2 per rank',
        icon: '/icons/paladin_strength.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: [],
        effects: [
          { type: 'stat_bonus', target: 'strength', value: 2, perRank: true }
        ]
      },
      {
        id: 'paladin_wisdom',
        name: 'Divine Wisdom',
        description: 'Increase wisdom by 2 per rank',
        icon: '/icons/paladin_wisdom.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: ['paladin_strength'],
        effects: [
          { type: 'stat_bonus', target: 'wisdom', value: 2, perRank: true }
        ]
      },
      {
        id: 'paladin_righteous_armor',
        name: 'Righteous Armor',
        description: 'Increase defense by 4 per rank',
        icon: '/icons/paladin_strength.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: ['paladin_strength'],
        effects: [
          { type: 'stat_bonus', target: 'defense', value: 4, perRank: true }
        ]
      },
      {
        id: 'paladin_holy_fervor',
        name: 'Holy Fervor',
        description: 'Increase magic attack by 3 per rank',
        icon: '/icons/paladin_wisdom.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['paladin_wisdom'],
        effects: [
          { type: 'stat_bonus', target: 'magicAttack', value: 3, perRank: true }
        ]
      },
      {
        id: 'paladin_sanctuary',
        name: 'Sanctuary',
        description: 'Increase magic defense by 5 per rank',
        icon: '/icons/paladin_strength.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['paladin_righteous_armor'],
        effects: [
          { type: 'stat_bonus', target: 'magicDefense', value: 5, perRank: true }
        ]
      },
      {
        id: 'paladin_crusader',
        name: "Crusader's Resolve",
        description: 'Increase maximum health by 60 per rank',
        icon: '/icons/paladin_strength.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 3,
        prerequisites: ['paladin_holy_fervor'],
        effects: [
          { type: 'stat_bonus', target: 'maxHp', value: 60, perRank: true }
        ]
      }
    ]
};

export const DRUID_TALENTS: TalentTree = {
    'nature': [
      {
        id: 'druid_intelligence',
        name: "Nature's Wisdom",
        description: 'Increase intelligence by 2 per rank',
        icon: '/icons/druid_intelligence.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: [],
        effects: [
          { type: 'stat_bonus', target: 'intelligence', value: 2, perRank: true }
        ]
      },
      {
        id: 'druid_vitality',
        name: 'Wild Vitality',
        description: 'Increase max HP by 50 per rank',
        icon: '/icons/druid_vitality.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: ['druid_intelligence'],
        effects: [
          { type: 'stat_bonus', target: 'maxHp', value: 50, perRank: true }
        ]
      },
      {
        id: 'druid_regen',
        name: 'Regrowth Mastery',
        description: 'Increase magic attack by 2 per rank',
        icon: '/icons/druid_regen.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['druid_vitality'],
        effects: [
          { type: 'stat_bonus', target: 'magicAttack', value: 2, perRank: true }
        ]
      },
      {
        id: 'druid_barkskin',
        name: 'Barkskin',
        description: 'Increase defense by 4 per rank',
        icon: '/icons/druid_vitality.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: ['druid_vitality'],
        effects: [
          { type: 'stat_bonus', target: 'defense', value: 4, perRank: true }
        ]
      },
      {
        id: 'druid_ancient_wisdom',
        name: 'Ancient Wisdom',
        description: 'Increase wisdom by 4 per rank',
        icon: '/icons/druid_intelligence.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['druid_intelligence'],
        effects: [
          { type: 'stat_bonus', target: 'wisdom', value: 4, perRank: true }
        ]
      },
      {
        id: 'druid_nature_wrath',
        name: 'Wrath of Nature',
        description: 'Increase critical chance by 2% per rank',
        icon: '/icons/druid_regen.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 3,
        prerequisites: ['druid_regen'],
        effects: [
          { type: 'stat_bonus', target: 'criticalChance', value: 0.02, perRank: true }
        ]
      }
    ]
};

export const SHAMAN_TALENTS: TalentTree = {
    'elemental': [
      {
        id: 'shaman_intelligence',
        name: 'Elemental Mastery',
        description: 'Increase intelligence by 2 per rank',
        icon: '/icons/shaman_intelligence.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: [],
        effects: [
          { type: 'stat_bonus', target: 'intelligence', value: 2, perRank: true }
        ]
      },
      {
        id: 'shaman_spirit',
        name: 'Spirit Power',
        description: 'Increase magic attack by 3 per rank',
        icon: '/icons/shaman_spirit.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['shaman_intelligence'],
        effects: [
          { type: 'stat_bonus', target: 'magicAttack', value: 3, perRank: true }
        ]
      },
      {
        id: 'shaman_totemic_ward',
        name: 'Totemic Ward',
        description: 'Increase defense by 4 per rank',
        icon: '/icons/shaman_intelligence.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: ['shaman_intelligence'],
        effects: [
          { type: 'stat_bonus', target: 'defense', value: 4, perRank: true }
        ]
      },
      {
        id: 'shaman_storm_reach',
        name: 'Storm Reach',
        description: 'Increase critical chance by 2% per rank',
        icon: '/icons/shaman_spirit.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['shaman_spirit'],
        effects: [
          { type: 'stat_bonus', target: 'criticalChance', value: 0.02, perRank: true }
        ]
      },
      {
        id: 'shaman_elemental_master',
        name: 'Avatar of Elements',
        description: 'Increase magic attack by 5 per rank',
        icon: '/icons/shaman_spirit.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 3,
        prerequisites: ['shaman_storm_reach'],
        effects: [
          { type: 'stat_bonus', target: 'magicAttack', value: 5, perRank: true }
        ]
      }
    ]
};
